import React, { useState } from "react";
import { useDispatch } from 'react-redux';
import { Formik } from 'formik';
import * as yup from 'yup';
import showErrMessage from "@components/ShowErrMessage";
import showMessage from "@components/ShowMessage";
import { spendGiftCode } from "@redux/modules/profile/profile.action";
import BannerSendIdea from "@assets/images/winwithcode.jpg";
import Form from 'react-bootstrap/Form';

const CodeEntry = () => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);

  const schema = yup.object({
    code: yup
      .string()
      .required("Lütfen bir kod giriniz!")
      .min(4, "Kod en az 4 karakter olmalıdır!")
      .max(20, "Kod en fazla 20 karakter olmalıdır!")
      .matches(
        /^[a-zA-Z0-9-_]+$/,
        "Kod sadece harf, rakam, tire (-) ve alt çizgi (_) içerebilir!"
      ),
  });

  const handleSubmit = async (values, { resetForm }) => {
    setIsLoading(true);
    try {
      await dispatch(spendGiftCode(values.code));
      showMessage("Kod başarıyla kullanıldı!");
      resetForm();
    } catch (err) {
      showErrMessage(
        err?.response?.data?.message ||
          "Kod kullanılamadı. Lütfen tekrar deneyiniz."
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <React.Fragment>
      <div className="mb-5">
        <h2 className="mb-sm-5 mb-4">Kod ile Puan Kazan</h2>
        <h5 class="text-blue mb-sm-5 mb-4">Size Verilen Kodu Giriniz</h5>

        <div className="row g-5">
          <div className="col-md-6 order-md-0 order-1">
            <Formik
              validationSchema={schema}
              onSubmit={handleSubmit}
              initialValues={{
                code: "",
              }}
            >
              {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
              }) => (
                <Form onSubmit={handleSubmit}>
                  <div className="form-floating mb-4">
                    <Form.Control
                      type="text"
                      className={`form-control ${
                        errors.code && touched.code ? "is-invalid" : ""
                      }`}
                      id="codeInput"
                      placeholder="Kodu giriniz"
                      value={values.code}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      name="code"
                    />
                    <label htmlFor="codeInput">Kodu Giriniz</label>
                    <Form.Control.Feedback type="invalid">
                      {errors.code && touched.code && errors.code}
                    </Form.Control.Feedback>
                  </div>

                  <button
                    type="submit"
                    className="btn btn-blue py-sm-3 py-2 px-sm-4 px-3 w-100"
                    disabled={isLoading}
                  >
                    {isLoading ? (
                      <span className="spinner-border spinner-border-sm me-3"></span>
                    ) : null}
                    Gönder
                  </button>
                </Form>
              )}
            </Formik>
          </div>
          <div className="col-md-6 order-md-1 order-0">
            <img
              src={BannerSendIdea}
              alt="Banner Send Idea"
              className="img-fluid rounded-3 mb-3"
            />
            <p className="mb-0 fw-light lh-lg">
              Kazandığınız ya da size verilen kodları buradan kullanabilirsiniz.
              Her kod yalnızca bir kez kullanılabilir ve kullanıldıktan sonra
              puanlarınız hesabınıza otomatik olarak tanımlanacaktır.
            </p>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default CodeEntry;
